var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app__close" }, [
    _c(
      "button",
      {
        staticClass: "app__closeButton",
        on: {
          click: function($event) {
            return _vm.closeApp()
          }
        }
      },
      [
        _c(
          "svg",
          {
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "35.76",
              height: "35.759",
              viewBox: "0 0 35.76 35.759"
            }
          },
          [
            _c(
              "g",
              {
                attrs: {
                  id: "Group_65",
                  "data-name": "Group 65",
                  transform: "translate(-801.118 712.73) rotate(-45)"
                }
              },
              [
                _c("path", {
                  attrs: {
                    id: "Path_55",
                    "data-name": "Path 55",
                    d: "M8481,968v47.571",
                    transform: "translate(-7410.548 -904)",
                    fill: "none",
                    stroke: "#000",
                    "stroke-width": "3"
                  }
                }),
                _vm._v(" "),
                _c("path", {
                  attrs: {
                    id: "Path_56",
                    "data-name": "Path 56",
                    d: "M0,0V47.571",
                    transform: "translate(1094.237 87.785) rotate(90)",
                    fill: "none",
                    stroke: "#000",
                    "stroke-width": "3"
                  }
                })
              ]
            )
          ]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }